module.exports = __webpack_public_path__ + "img/stock1.14da7dad.png";